import * as React from 'react';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import Helmet from 'react-helmet';
import { findIndex } from 'lodash';
import { Breadcrumbs, Hero, Loader } from '../';
import Error from '../../views/Error';

interface Props {
  auth: any;
  requireAuth: boolean;
  requireNoAuth: boolean;
  requireGlobalAdmin: boolean;
  requirePermission: string;
  title: string;
  breadcrumbs?: Array<{ link: string; text: string }>;
  loading: boolean;
  error: any;
  children: any;
  dispatch: Function;
  ready?: boolean;
}

class RouteWrapper extends React.Component<Props> {
  componentDidMount() {
    if (!this.props.auth.isFetching) {
      if (this.props.auth.isAuthenticated && this.props.requireNoAuth) {
        this.props.dispatch(replace('/dashboard'));
      }
    }
  }

  render() {
    if (!this.props.auth.isFetching) {
      if (!this.props.auth.isAuthenticated && this.props.requireAuth) {
        return <Error title="You must be logged in to view this page" />;
      }
      if (!this.props.auth.isGlobalAdmin && this.props.requireGlobalAdmin) {
        return <Error title="You do not have access to view this page" />;
      }
    }
    if (this.props.requirePermission) {
      const adminIndex = findIndex(this.props.auth.user.permissions, {
        permission: 'ADMIN',
      });
      if (adminIndex === -1) {
        const index = findIndex(this.props.auth.user.permissions, {
          permission: this.props.requirePermission,
        });
        if (index === -1 && !this.props.auth.isGlobalAdmin) {
          return (
            <Error title="You do not have permission to access this page" />
          );
        }
      }
    }
    if (this.props.error) {
      return (
        <Error
          title={
            typeof this.props.error === 'string'
              ? this.props.error
              : 'An error occurred'
          }
        />
      );
    }
    const isReady = this.props.ready === undefined || this.props.ready;
    const body = [];
    if (this.props.breadcrumbs) {
      body.push(
        <div className="container" key="breadcrumbs">
          {this.props.loading && (
            <span className="icon is-pulled-right">
              <i className="fa fa-refresh fa-spin" />
            </span>
          )}
          <Breadcrumbs items={this.props.breadcrumbs} />
        </div>,
      );
    }
    body.push(this.props.children);
    return (
      <section className="app-content__view">
        <Helmet title={isReady ? this.props.title : 'Loading...'} />
        {isReady ? (
          body
        ) : (
          <Hero className="is-fullheight has-text-centered">
            <Loader fullwidth />
            <small className="has-text-grey-light">
              Loading, please wait...
            </small>
          </Hero>
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(RouteWrapper);
